<template>
    <div>
        List
    </div>
</template>
<script>
export default {
    name: 'PaymentListPage',
}
</script>